import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './Click-Outside-Directive/clickOutside.directive';
import { DraggableDirective } from './Draggable/draggable.directive';
import { AnchorRouteDirective } from './Anchor-Route/anchorRoute.directive';
import { InfiniteScrollDirective } from './Infinite-Scroll/infiniteScroll.directive';
import { NumbersOnlyDirective } from './Numbers-Only/numbersOnly.directive';
import { InputMaskDirective } from './Input-Mask/inputMask.directive';
import { ResizableDirective } from './Resizable/resizable.directive';
import { ToPercentDirective } from './To-Percent/toPercent.directive';
import { LineLimitDirective } from './Line-Limit/lineLimit.directive';
import { DecimalNumberDirective } from './Decimal-Number-Input/decimal-number-input.directive';
import { NumberDirective } from './Number-Input/number-input.directive';
import { DragAndDropListModule } from './Drag-And-Drop-List/dragAndDropList.module';
import { FileDropDirective } from './File-Drop/fileDrop.directive';

@NgModule({
    imports: [
        CommonModule,
        AnchorRouteDirective,
        DragAndDropListModule,
        ClickOutsideDirective,
        DraggableDirective,
        NumbersOnlyDirective,
        ToPercentDirective,
        FileDropDirective,
    ],
    declarations: [
        DecimalNumberDirective,
        InfiniteScrollDirective,
        InputMaskDirective,
        LineLimitDirective,
        NumberDirective,
        ResizableDirective,
    ],
    exports: [
        AnchorRouteDirective,
        ClickOutsideDirective,
        DecimalNumberDirective,
        DraggableDirective,
        FileDropDirective,
        InfiniteScrollDirective,
        InputMaskDirective,
        LineLimitDirective,
        NumberDirective,
        NumbersOnlyDirective,
        ResizableDirective,
        ToPercentDirective,
    ],
})
export class DirectivesModule {}
